import CustomError from "models/CustomError"
import { OutgoingInvoice } from "models/OutgoingInvoice"
import { useCallback, useEffect, useState } from "react"
import AssetService from "services/AssetService"
import toastMessages from "stores/toastMessages"
import { Guid } from "@/types"

interface IUseOutgoingInvoiceParams {
    invoiceId: Guid | null
    onFail?(e: CustomError): void
}

export default function useOutgoingInvoice({ invoiceId, onFail: onFailProp }: IUseOutgoingInvoiceParams) {
    const [invoice, setInvoice] = useState<OutgoingInvoice | null>(null)
    const [onFail] = useState<((e: CustomError) => void) | undefined>(() => onFailProp)

    const fetchInvoice = useCallback(async () => {
        if (!invoiceId) return
        try {
            const fetchedInvoice = await AssetService.getOutgoingInvoice(invoiceId)
            setInvoice(fetchedInvoice)
        } catch (e) {
            if (onFail && e instanceof CustomError) {
                onFail(e)
            } else {
                toastMessages.showSystemError()
            }
        }
    }, [invoiceId, onFail])

    useEffect(() => {
        fetchInvoice()
    }, [fetchInvoice])

    return {
        invoice
    }
}
